import Page from "components/Page";

const StarringYouAILandingPage = () => {
  return <Page slug="starring-you-ai" />;
};

export default StarringYouAILandingPage;
